import { Item } from '../../../data/item';
import { useLanguage } from '../../../hooks/useLanguage';

interface ProductProps {
  items: Item[];
}

export default function Product({ items }: ProductProps) {
  const { language } = useLanguage();

  return (
    <div className="px-2 py-2 lg:p-[1vw] space-y-3 lg:space-y-[0.6vw]">
      {items.map((item) => (
        <div
          key={item.id}
          className="bg-white rounded-lg p-6 lg:p-[2.8vw] shadow-md"
        >
          {/* Title */}
          <h2 className="text-lg lg:text-[1.2vw] font-bold mb-3 lg:mb-[0.9vw]">
            {item.title[language]}
          </h2>

          {/* Image - Mobile first */}
          {item.image && (
            <div className="mb-[2vh] lg:hidden">
              <img
                src={item.image}
                alt={item.title[language]}
                className="w-full h-auto rounded-lg object-cover"
              />
            </div>
          )}

          {/* Description with Image - Desktop */}
          <div className="flex flex-col lg:flex-row gap-3 lg:gap-[0.8vw] mb-4 lg:mb-[1.25vw]">
            <div className="flex-1">
              <p className="text-sm lg:text-[0.95vw] text-gray-700 leading-relaxed">
                {item.description[language]}
              </p>
            </div>
            {item.image && (
              <div className="hidden lg:block w-[12vw] flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title[language]}
                  className="w-full h-auto rounded-lg object-cover"
                />
              </div>
            )}
          </div>

          {/* Highlight Section */}
          <div className="mb-4 lg:mb-[1.25vw]">
            <h3 className="text-base lg:text-[1.05vw] font-bold mb-2 lg:mb-[0.7vw] flex items-center gap-2 lg:gap-[0.4vw]">
              {item.highlightTitle[language]}
            </h3>
            <ul className="space-y-2 list-disc list-inside">
              {item.highlightDescription[language].map((point, index) => (
                <li
                  key={index}
                  className="text-sm lg:text-[0.95vw] text-gray-700"
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>

          {/* Perfect For Section */}
          <div>
            <h3 className="text-base lg:text-[1.05vw] font-bold mb-2 lg:mb-[0.7vw]">
              {item.perfectForTitle[language]}
            </h3>
            <ul className="list-disc list-inside">
              <li className="text-sm lg:text-[0.95vw] text-gray-700">
                {item.perfectForDescription[language]}
              </li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}
